export default (chunkLength, coll) => {
    const result = [];
    let current = [];
    coll.forEach((item) => {
        if (current.length < chunkLength) {
            current.push(item);
        }
        if (current.length === chunkLength) {
            result.push(current);
            current = [];
        }
    });
    if (current.length > 0) {
        result.push(current);
    }
    return result;
};
//# sourceMappingURL=chunk.mjs.map